import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex gap-y-8 flex-row flex-wrap" }
const _hoisted_2 = { class: "pr-6" }
const _hoisted_3 = /*#__PURE__*/_createVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_PrintManifestClearance = _resolveComponent("PrintManifestClearance")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DetailLayout, {
      scrollSidebar: "",
      customClass: "px-0",
      onBack: _ctx.goBack,
      title: _ctx.getTitle,
      loading: _ctx.isLoading,
      error: _ctx.isError,
      errorType: _ctx.errorCause,
      onTryAgain: _ctx.getDetailClearance
    }, {
      data: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_DataWrapper, {
            label: "No. Clearance",
            class: "w-full",
            value: _ctx.detailData.clearanceNo
          }, null, 8, ["value"]),
          _createVNode(_component_DataWrapper, {
            label: "Total Berat STT",
            class: "w-6/12",
            value: `${_ctx.detailData.clearanceTotalWeight} Kg`
          }, null, 8, ["value"]),
          _createVNode(_component_DataWrapper, {
            label: "Total Koli",
            value: _ctx.detailData.clearanceTotalPieces,
            class: "w-6/12"
          }, null, 8, ["value"]),
          _createVNode(_component_DataWrapper, {
            label: "Total Harga Barang",
            value: _ctx.formatPrice(_ctx.detailData.clearanceTotalGoodsPrice),
            class: "w-6/12"
          }, null, 8, ["value"])
        ]),
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_TableV2, {
            data: _ctx.detailData.clearanceDetailStt,
            columns: _ctx.columns,
            borderTop: false,
            hidePagination: true,
            isRightFreeze: true,
            isPinnedScrollBottom: false,
            totalColumnFreeze: 0
          }, null, 8, ["data", "columns"])
        ])
      ]),
      "sub-data": _withCtx(() => [
        _createVNode(_component_DataWrapper, {
          label: "Tanggal Dibuat",
          value: _ctx.convertCreatedAt,
          caption: _ctx.detailData.clearanceCreatedName
        }, null, 8, ["value", "caption"]),
        _hoisted_3,
        _createVNode(_component_DataWrapper, { label: "Print Clearance" }, {
          default: _withCtx(() => [
            _createVNode(_component_LpButton, {
              onClick: _ctx.printManifest,
              class: "mt-3 w-48",
              flat: "",
              dense: "",
              iconLeft: "invoice",
              title: "Print Manifest"
            }, null, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onBack", "title", "loading", "error", "errorType", "onTryAgain"]),
    _createVNode(_component_PrintManifestClearance, { ref: "printManifest" }, null, 512)
  ], 64))
}